import { useCallback, useState } from 'react';

/**
 * @param {number} minZoom
 * @param {number} maxZoom
 * @return {{zoom: number, zoomIn: function(): void, zoomOut: function(): void}}
 */
const useZoom = (minZoom, maxZoom) => {
  const [zoom, setZoom] = useState(1);

  const zoomIn = useCallback(() => {
    setZoom((zoom) => Math.min(zoom + 1, maxZoom));
  }, [maxZoom]);

  const zoomOut = useCallback(() => {
    setZoom((zoom) => Math.max(minZoom, zoom - 1));
  }, [minZoom]);

  return {
    zoom,
    zoomIn,
    zoomOut,
  };
};

export default useZoom;
